import React, { FC, ReactElement, useContext } from 'react'
import Dialog from '../../../../React/Common/Components/Modal/Dialog'
import { ModalExitPromptContextProvider } from '../../../../React/Common/Components/Modal/ModalExitPromptContext'
import { CommonFormContext, FormContextType } from '../../../../React/Common/Contexts/CommonFormContext'
import { InlinePromptProps } from '../../../../React/Common/Components/InlinePrompt/InlinePrompt'

type Props = {
    className?: string
    isOpen: boolean
    onOpen?: () => void
    onClose: () => void
    closeOnBackdropClick?: boolean
    isClosableWithXButton?: boolean
    children: ReactElement | ReactElement[]
    inlineExitPromptSettings?: InlinePromptProps
    onExited?: () => void
    isViewOnly?: boolean
}

export const Modal: FC<Props> = ({
    className,
    isOpen,
    onOpen,
    onClose,
    closeOnBackdropClick = true,
    isClosableWithXButton = true,
    inlineExitPromptSettings,
    onExited,
    children,
    isViewOnly
}: Props): ReactElement => {
    const commonForm: Nullable<FormContextType> = useContext(CommonFormContext)

    return (
        <ModalExitPromptContextProvider>
            <Dialog
                isOpen={isOpen}
                onOpen={onOpen}
                onClose={onClose}
                isClosableWithXButton={isClosableWithXButton}
                closeOnBackdropClick={closeOnBackdropClick}
                classNames={`router-modal ${className}`}
                inlineExitPromptSettings={!!commonForm && !commonForm.isTouched ? undefined : inlineExitPromptSettings}
                onExited={onExited}
                isViewOnly={isViewOnly}
            >
                {children}
            </Dialog>
        </ModalExitPromptContextProvider>
    )
}
